import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const OperationsOptimizationReportRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--optimization-report']}>
    <Route index element={<Index />} />
  </SubRouter>
))
